export default "__VITE_ASSET__C13f2kCg__"